import React from 'react';
import { render } from 'react-dom';
import BkToolsApp from 'bk-web-app/BkToolsApp';
import { init as initUsageTracker } from 'bk-web-app/utils/usageTracker';

initUsageTracker();

render(<BkToolsApp />, document.getElementById('container'));

if (module.hot) {
    module.hot.accept();
}